import { DrawerBody, Flex, Stack, Text } from '@chakra-ui/react';
import { Service } from 'shared/models/service';
import { PeriodicityBadge } from '../atoms/SummaryBadge';
import { useCreateContractModalContext } from '../modals/CreateContractModal/ModalContext';
import { ContractModalFooter } from '../molecules';
import { PlanSelector } from '../molecules/PlanSelector';
import AddedServicesList from './AddedServicesList';

interface ServicesStepProps {
  onClose: () => void;
  onNext?: () => void;
}

const ServicesStep: React.FC<ServicesStepProps> = ({ onClose, onNext }) => {
  const {
    nextStep,
    product,
    selectedPlan,
    setSelectedPlan,
    addedProducts,
    addPlan,
    contract,
    periodicity,
  } = useCreateContractModalContext();

  const addedIds = addedProducts
    .map((p) => p.selectedService?.id)
    .filter((id): id is number => !!id);

  const handleSave = (plan: Service) => {
    addPlan(plan);
  };

  const handleNext = () => {
    (onNext ?? nextStep)();
  };

  return (
    <Flex direction="column" flex={1} minH={0} overflow="hidden">
      <DrawerBody scrollBehavior="auto" pb="0">
        <Stack py="1rem" minH="100%" spacing={8}>
          <Flex justify="space-between" align="center" px={2}>
            <Text fontWeight="semibold" fontSize="1.25rem">
              Qual plano ou serviço quer adicionar?
            </Text>
            <PeriodicityBadge periodicity={periodicity} />
          </Flex>

          <PlanSelector
            product={product}
            periodicity={periodicity}
            selectedPlan={selectedPlan}
            setSelectedPlan={setSelectedPlan}
            addedServiceIds={addedIds}
            onSave={handleSave}
          />

          <AddedServicesList showRemove showDiscount={!contract} />
        </Stack>
      </DrawerBody>

      <ContractModalFooter
        onCancel={onClose}
        onNext={handleNext}
        isNextDisabled={!addedProducts.length}
      />
    </Flex>
  );
};

export default ServicesStep;
